import DefaultDesc from './DefaultDesc';

export default DefaultDesc;
